export const DELIVERY_METHOD = {
  1: '貨運宅配',
  2: '到店取貨',
  3: '黑貓站取',
};


export const ORDER_STATUS = {
  1: '訂單成立',
  2: '備貨中',
  3: '已出貨',
  4: '付款未成功',
  5: '訂單取消',
  6: '已理貨'  
};


export const PAYMENT_METHOD = {
  1: '線上刷卡',
  2: '貨到付款',
  3: '線上匯款',
  4: '其他',
  5: '線上刷卡(分期)'
};


export const INVOICE_TYPE = {
  1: '捐贈發票',
  2: '一般發票',
  3: '公司發票'
};


export const DELIVERY_TIME = {
  0: '不指定',
  1: '早上',
  2: '下午'
};
